import type { CommandBody } from '../CrossOriginMessage';

/**
 * Indicates that the embedded workspace is waiting for the view.
 */
export class WaitingViewCommandBody implements CommandBody {}
